import { useState, useCallback } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { InventoryInput } from 'domain/entities/Inventory'
import { GraphQLInventoryRepository } from 'infrastructure/graphql/InventoryRepositoryImpl'

export function useCreateInventory() {
  const { getIdTokenClaims } = useAuth0()

  const [creating, setCreating] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const createInventory = useCallback(
    async (input: InventoryInput) => {
      setCreating(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLInventoryRepository(getToken)
        const created = await repo.create(input)
        return created
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setCreating(false)
      }
    },
    [getIdTokenClaims]
  )

  return { createInventory, creating, error }
}
